import React, { useCallback, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronLeft } from '@fortawesome/sharp-light-svg-icons/faCircleChevronLeft';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import style from './toggle-left-nav.module.less';

const messages = defineMessages({
  hideLeftNavTitle: {
    description: 'Icon title text for hiding left navigation',
    defaultMessage: 'Hide left navigation',
    id: 'Zo0ZDF',
  },
  showLeftNavTitle: {
    description: 'Icon title text for showing left navigation',
    defaultMessage: 'Show left navigation',
    id: 'QakkOd',
  },
});

const ToggleLeftNav = ({ children, className = '' }) => {
  const intl = useIntl();
  const [isLeftNavOpen, setIsLeftNavOpen] = useState(true);

  const toggleSideNav = useCallback(() => {
    setIsLeftNavOpen((prevState) => !prevState);
  }, []);

  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  const iconTitle = isLeftNavOpen ? messages.hideLeftNavTitle : messages.showLeftNavTitle;

  return (
    <>
      <div
        className={classnames(style['left-nav-toggle-wrapper'], { [style['left-nav-toggle-wrapper-left']]: !isLeftNavOpen }, className)}
        onClick={toggleSideNav}
        style={zIndexStyle}
      >
        <FontAwesomeIcon className={style['icon-styles']} icon={faCircleChevronLeft} title={intl.formatMessage(iconTitle)} />
      </div>
      <div
        className={classnames(style['left-nav'], {
          [style['hide-left-nav']]: !isLeftNavOpen,
        })}
      >
        {children}
      </div>
    </>
  );
};

ToggleLeftNav.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
};

export default ToggleLeftNav;
